export default {"src":"/_next/static/media/upay.d7fd6134.svg","height":46,"width":100,"blurWidth":0,"blurHeight":0};